<template>
	<div class="multiselect-group" :class="{ small: small }">
		<div class="multiselect-group__align">
			<label class="multiselect-group__label">{{ label }}</label>
			<InfoTooltip
				:class="informationText.length ? '' : 'hide'"
				:informationText="informationText"
			/>
		</div>
		<GenericMultiselect
			class="multiselect-group__input"
			:ref="type"
			:alertClass="alert"
			:options="options"
			:placeholder="placeholder"
			:fullWidth="!isWeb"
			:searchable="true"
			:clearOnOpen="false"
			:needType="true"
			:type="type"
			:multiple="multiple"
			:disabled="disabled"
			@changeInput="changeMultiselectInput"
		/>
		<small class="multiselect-group__input--required" v-if="alert"> Campo obrigatório. </small>
	</div>
</template>

<script>
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import InfoTooltip from '@/components/shared/InfoTooltip/InfoTooltip.vue';

export default {
	name: 'MultiselectGroup',
	directives: {},
	components: {
		GenericMultiselect,
		InfoTooltip,
	},
	props: {
		isWeb: {
			required: true,
		},
		label: {
			required: true,
		},
		options: {
			required: true,
		},
		placeholder: {
			required: true,
		},
		alert: {
			required: true,
		},
		type: {
			required: true,
		},
		small: {
			required: false,
		},
		multiple: {
			default: false,
		},
		informationText: {
			default: '',
		},
		disabled: {
			default: false,
		}
	},
	methods: {
		setValue(value) {
			this.$refs[this.type].setValue(value);
		},
		changeMultiselectInput(param) {
			this.$emit('changeMultiselectInput', param);
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'MultiselectGroup.scss';
</style>
